/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux'

import BackButton from '../../components/BackButton/BackButton';
import styles from './BulkSpocForm.module.css';
// import SpocForm from '../../components/SpocForm/SpocForm'
import BulkSpocForm from '../../components/BulkSpocUpload/BulkSpoc'
// import  ReportForm  from '../../components/ReportForm/ReportForm';

import { CustomTab } from '../../atomicComponents';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';


function SpocBulkUploadDelte({ product }) {
    const history = useHistory();
    const redirectToProcessPage = () => {
        history.push('/home');
    };


    return (
        <>
            <div className={styles.container} style={{ boxSizing: 'border-box' }}>
                    <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

                    <BackButton
                        action="Home"
                        handleClick={redirectToProcessPage}
                    />
                </div>
                <div className={styles.processHeader}>
                    <div className={styles.CustomTabClass} >
                        <CustomTab title="Project Linkage" withOutCount isSelected />
                    </div>
                    <div className={styles.processTopbar}>

                        <UserInfoPanel
                            userInfo={[{
                                "Name": "Siddesh Jadhav",
                                "SAP ID": 122355, "BC No": "122355",
                                "LOC": "Engineering and Research Center"
                            }]} />

                    </div>
                    {/* <div style={{ width: '30%' }} >
          <div className={styles.processTopbar}>
           <div className={styles.Adobtitle}>
            <span className={styles.spanTitle}>Chassis Number</span>
            <span>{chassis}</span>
           </div> 

        
          </div>
          </div>
          <div style={{ width: '30%' }} > 
          <div className={styles.processTopbar}>
           <div className={styles.Adobtitle}>
            <span className={styles.spanTitle}>Material Number</span>
            <span>{materialNo}</span>
           </div> 

        
          </div>
          </div> */}
                </div>

                <BulkSpocForm redirectToProcessPage={redirectToProcessPage} />

            </div>
        </>
    )
}
const mapStateToProps = state => ({
    product: state.product,
    counter: state.counter.value,
    baseUrl: state.counter.baseUrl,
    auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({

});
SpocBulkUploadDelte.propTypes = {

    product: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(SpocBulkUploadDelte); 
